<template>
  <send-message-modal v-if="isSendMessageModalOpened" :is-send-message-modal-opened="isSendMessageModalOpened"
    :refresh-data="getResponseMessages" :asset-ids="assetIds" @refresh-data="getResponseMessages"
    @toggle-modal="isSendMessageModalOpened = false" />
  <messages-view-modal v-if="isMessagesViewModalOpened" :is-modal-opened="isMessagesViewModalOpened" :asset-id="assetId"
    @toggle-modal="isMessagesViewModalOpened = false" />
  <main-section>
    <loader v-if="isLoading" />
    <div class="h-full" v-else>
      <table-action-header :button-text="$t('ResponseMessages.SendMessage')" :icon="['fas', 'add']"
        :title="$t('ResponseMessages.Title')" :permission-id="permissions.CommitAssignmentDeviceAction" description=" "
        @execute-method="toggleSendMessageModal" />
      <custom-table table-height="90%" :is-data-source-loading="isDataSourceLoading"
        :table-data="paginatedResponseMessages.items" :table-headers="tableHeaders" :multiselect="true"
        :show-per-page="25" :is-action-list-not-displayed="true" @selected-rows="getSelectedRow"
        @force-refresh="getResponseMessages()" @view-messages="viewMessages" />
    </div>
  </main-section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainSection from "@/core/Components/MainSection.vue";
import CustomTable from "@/core/Components/CustomTable.vue";
import ResponseMessagesService from "@/modules/ResponseMessages/Services/ResponseMessagesService";
import {
  LastResponseMessage,
  LastResponseMessagesObject,
} from "@/modules/ResponseMessages/Services/ResponseMessagesTypes";
import { useToast } from "vue-toastification";
import { ErrorMessageFormatter } from "@/core/Services/GlobalFunctions";
import AssignmentService from "@/modules/Devices/Submodules/Assignments/Services/AssignmentService";
import TableActionHeader from "@/core/Components/TableActionHeader.vue";
import SendMessageModal from "@/modules/ResponseMessages/Components/SendMessageModal.vue";
import Loader from "@/core/Components/Loader.vue";
import MessagesViewModal from "@/modules/ResponseMessages/Components/MessagesViewModal.vue";
import { Permissions } from "@/core/Services/Enums";
import SensorService from "@/modules/Parkom/Submodules/Sensors/Services/SensorService";
import { Sensor } from "@/modules/Parkom/Submodules/Sensors/Services/SensorTypes";

export default defineComponent({
  components: {
    MessagesViewModal,
    Loader,
    TableActionHeader,
    CustomTable,
    MainSection,
    SendMessageModal
  },
  data() {
    return {
      responseMessagesService: new ResponseMessagesService(),
      assignmentService: new AssignmentService(),
      sensorService: new SensorService(),
      sensors: [] as Sensor[],
      paginatedResponseMessages: {} as LastResponseMessagesObject,
      selectedResponseMessage: {} as LastResponseMessage,
      responseMessages: [] as LastResponseMessage[],
      assetIds: [] as number[],
      assetId: 0,
      permissions: Permissions,
      toast: useToast(),
      isLoading: false,
      isDataSourceLoading: false,
      isSendMessageModalOpened: false,
      isMessagesViewModalOpened: false,
      tableHeaders: {
        id: { header: "ResponseMessages.ID", visible: false },
        assetName: { header: "ResponseMessages.AssetName", visible: true },
        mac: { header: "ResponseMessages.MAC", visible: true },
        parkingSpaceLabel: {
          header: "ParkingSpots.Space",
          visible: true,
        },
        imei: { header: "ResponseMessages.IMEI", visible: true },
        lastTimeDeviceSentData: {
          header: "ResponseMessages.LastDataSent",
          visible: true,
        },
        serialNumber: {
          header: "ResponseMessages.SerialNumber",
          visible: true,
        },
        "responseMessages.message": {
          header: "ResponseMessages.LastMessage",
          visible: true,
        },
        allResponseMessages: {
          header: "ResponseMessages.AllResponseMessages",
          visible: true,
        },
        firmwareUpdateStatus: {
          header: "ResponseMessages.FwUpdate",
          visible: true,
        },
        hwRevision: {
          header: "ResponseMessages.HwRevision",
          visible: true,
        },
        firmwareVersion: {
          header: "ResponseMessages.FwVersion",
          visible: true,
        }
      },
    };
  },
  async created() {
    this.isLoading = true;
    try {
      await this.getResponseMessages();
    } catch (error) {
      this.toast.error(ErrorMessageFormatter(error));
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    async getResponseMessages() {
      this.isDataSourceLoading = true;
      try {
        this.paginatedResponseMessages = await this.responseMessagesService.getResponseMessages(
          1,
          10000
        );
      } catch (error) {
        this.toast.error(ErrorMessageFormatter(error));
      } finally {
        this.isDataSourceLoading = false;
      }
    },

    async viewMessages(asset: { id: number }) {
      this.assetId = asset.id;
      this.isMessagesViewModalOpened = true;
    },
    sentMessages() {
      this.isMessagesViewModalOpened = true;
    },
    getSelectedRow(selectedRows: LastResponseMessage[]) {
      this.selectedResponseMessage = selectedRows[0];
      this.assetIds = selectedRows.map((message) => message.id);
    },
    toggleSendMessageModal() {
      this.isSendMessageModalOpened = !this.isSendMessageModalOpened;
    },
    toggleMessagesViewModal() {
      this.isMessagesViewModalOpened = !this.isMessagesViewModalOpened;
    },
  },
});
</script>

<style scoped></style>
